import { writable } from 'svelte/store';
import { is_subscribed, set_cookie } from './cookies.js';

// Create a writable store for subscription status
export const is_subscribed_store = writable(is_subscribed());

// Helper function to update both the store and cookie
export function update_subscription_status(subscribed) {
  is_subscribed_store.set(subscribed);
  if (subscribed) {
    set_cookie('is_subscribed', 'true');
  } else {
    set_cookie('is_subscribed', 'false');
  }
} 